export default "__VITE_ASSET__D0O8bL8D__"